import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AppService} from '@irb/app.service';
import {IrbModelsEvents} from '@irb/irb-models/irb-models.events';

@Component({ standalone: false,
    selector: 'dux-blended-mod-alloc-group-cell',
    template: `
        <div>
          @if (!params.data.securityId) {
            <div><a class="nav-link-text"
              (click)="openSecurityModel()"
            >{{showSecurityModelName}}</a></div>
          }
          @if (params.data.securityId) {
            <div>{{showSecurityModelName}}</div>
          }
        </div>
        `,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class BlendedModelAllocationGroupcellComponent {
    params: any = {};
    showSecurityModelName: any;

    constructor(private as: AppService){

    }
    
    agInit(params: any): void {
        this.params = params;
        this.showSecurityModelName = this.params.data.securityModelName;
    }
    openSecurityModel(){
        this.params.data.fullscreen = true;
        this.params.data.showNextPrev =  false;
        this.params.data.typeModel =  "Security";
        this.params.data.type =  "Base";
        this.params.data.modelId = this.params.data.securityModelId;
        this.params.data.isDraft = false;
        this.params.data.approvedModelId = null;
        this.params.data.slot = "C";
        this.params.data.openFromBlended=true;
        this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MODEL, this.params.data);
    }
    refresh(): boolean {
        return true;
    }
}
